import React from "react";
import { object, array } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { getDomainSlugFromSections } from "../../../isomorphic/components/utils/utils";
import { StoryPageBase } from "./story";

class StoryPreviewPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.collectStoryData();
  }

  collectStoryData() {
    global.addEventListener("message", (event) => {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const previewParams = urlParams.get("previewParams");
      if (event.data.story) {
        this.setState({
          story: event.data.story,
          relatedStories: Array(4).fill(event.data),
          preview: true,
          index: 0,
        });
        const currentFirstSection = get(event.data.story, ["sections", "0", "name"], "");
        const currentDomainSlug = getDomainSlugFromSections(this.props.sections, currentFirstSection);
        if (currentDomainSlug && previewParams === null) {
          window.location = "?previewParams=" + currentDomainSlug;
        }
      }
    });
  }

  render() {
    if (!this.state.story) return <div />;
    return StoryPageBase(this.state, this.props.config);
  }
}

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
});

const StoryPagePreview = connect(mapStateToProps)(StoryPreviewPage);
StoryPagePreview.propTypes = {
  config: object,
};

StoryPreviewPage.propTypes = {
  config: object,
  sections: array,
};

export { StoryPagePreview };
